<template>
    <div class="grey-body">
        <public-header></public-header>
        <div class="height70"></div>
        <div class="box1200 margin-bottom-20">

            <!-- <div class="height60"></div> -->
            <!--<latest-join></latest-join>-->
            <div class="flex margin-top-20">
                <div class="box890">
                    <el-tabs v-model="activeName" type="border-card" class="task-list" @tab-click="changeTab(activeName)">
                        <el-tab-pane name="first">
                            <span slot="label"><i class="el-icon-tickets"></i> 进行中</span>
                            <on-going></on-going>
                        </el-tab-pane>
                        <el-tab-pane name="two">
                            <span slot="label"><i class="el-icon-time"></i> 未开始</span>
                            <no-start></no-start>
                        </el-tab-pane>
                        <el-tab-pane name="three">
                            <span slot="label"><i class="el-icon-date"></i> 往期推广</span>
                            <over></over>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="box290 margin-left-20">
                    <data-statistics></data-statistics>
                    <div class="ranking-nav white-bg margin-top-20">
                        <el-button :class="{ 'item': show, 'active': isDaRen }" @click="showDaRen">达人排行榜</el-button>
                        <el-button :class="{ 'item': show, 'active': isEp }" @click="showEp">企业排行榜</el-button>
                    </div>
                    <enterprise-ranking v-show="isEp"></enterprise-ranking>
                    <daren-ranking v-show="isDaRen"></daren-ranking>
                </div>
            </div>
        </div>
        <public-footer></public-footer>
        <back-top></back-top>
    </div>
</template>
<script>
    import PublicHeader from '@/components/PublicHeader.vue'
    import PublicFooter from "@/components/PublicFooter.vue";
    import BackTop from "@/components/BackTop.vue";
    import OnGoing from './components/OnGoing'
    import NoStart from './components/NoStart'
    import Over from './components/Over'
    import DataStatistics from './components/DataStatistics'
    // import LatestJoin from './components/LatestJoin'
    import DarenRanking from './components/Ranking'
    import EnterpriseRanking from './components/EnterpriseRanking'
    export default {
        name: 'List',
        data () {
            return {
                show: true,
                isEp: false,
                isDaRen: true,
                newData: null,
                activeName: sessionStorage.getItem('activeName')
            }
        },
        components: {
            EnterpriseRanking,
            PublicHeader,
            BackTop,
            OnGoing,
            NoStart,
            Over,
            DataStatistics,
            DarenRanking,
            PublicFooter
        },
        methods: {
            showEp () {
                this.isEp = true;
                this.isDaRen = false;
            },
            showDaRen () {
                this.isEp = false;
                this.isDaRen = true;
            },
            change(data) {
                this.newData = data;
                window.console.log(data)
            },
            changeTab (activeName) {
                sessionStorage.setItem('activeName',activeName)
            }
        },
        created () {
            if (!sessionStorage.activeName) {
                this.activeName = 'first'
            }
            window.onbeforeunload = function() {
                sessionStorage.removeItem('activeName')
            };
        }
    }
</script>
<style>
    .task-list .el-tabs__content{padding:0;}
    .task-list .item{border-bottom:1px #eee solid;padding:20px;}
    .task-list .item .item-top .price{font-size:16px;font-weight: bold;}
    .task-list .item .item-top .title{font-size:16px;margin:0 10px;}
    .task-list .item .item-center{font-size:12px;margin:10px 0;color:#666;}
    .task-list .item .item-center .click{margin-right:10px;}
    .task-list .item .item-center .number{margin-right:10px;}
    .task-list .item .item-center .time{margin-right:10px;}
    .task-list .item .item-center .icon{color:#ccc;}
    .task-list .item .item-bottom .logo .logo-pic{width:26px;height:26px;border-radius:50%;margin-right:10px;}
    .task-list .item .item-bottom{color:#999;}
    .loading{text-align:center;color:#999;padding:20px 0;}
    .ranking-nav{background: #fff;}
    .ranking-nav .item{border:none;border-radius: 0;margin-left:0;width: 50%;height:42px;}
    .ranking-nav .active{background: #FF741F;color:#fff;}
    .el-tabs--border-card{box-shadow: 0 0 0 rgba(0, 0, 0, .0);border:none;background: none;}
    .el-tabs--border-card>.el-tabs__header{background:#fff;}
    .el-tabs--border-card>.el-tabs__header{margin-bottom:10px;}
    .el-tabs__content{background: #fff;}
    .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{border:none;}
    .el-tabs--border-card>.el-tabs__header{border:none;}
    .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{background: #FF741F;color:#fff;}
    .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active:hover{color:#fff;}
    .el-tabs--border-card>.el-tabs__header .el-tabs__item{border:none;}
</style>
